import { memo } from 'react';

import PropTypes from 'prop-types';

const Alert = memo(({ msg, type }) => (
  <div className={`alert alert-${type}`} role='alert'>
    {msg}
  </div>
));

Alert.displayName = 'Alert';

Alert.defaultProps = {
  msg: 'Success!',
  type: 'success'
};

Alert.propTypes = {
  msg: PropTypes.string,
  type: PropTypes.string
};

export default Alert;
